import { useSnackbar } from 'notistack';

const SNACKBAR_OPTIONS = {
  anchorOrigin: {
    horizontal: 'right',
    vertical: 'top',
  },
  autoHideDuration: 4000,
};

const extractErrorMessage = (error) => {
  if (!error) return null;
  const data = error?.response?.data;
  if (data) {
    if (Array.isArray(data.errors) && data.errors.length > 0) {
      const first = data.errors[0];
      if (typeof first === 'string') return first;
      if (first?.message) return first.message;
    }
    if (typeof data.detail === 'string') return data.detail;
    if (typeof data === 'string') return data;
  }
  if (error?.message) return error.message;
  return null;
};

export function useStyledSnackbar() {
  const { enqueueSnackbar } = useSnackbar();

  const successSnackbar = (message) =>
    enqueueSnackbar(message, { variant: 'success', ...SNACKBAR_OPTIONS });

  const errorSnackbar = (message, error) => {
    const detail = extractErrorMessage(error);
    const text = detail ? `${message} ${detail}` : message;
    enqueueSnackbar(text, { variant: 'error', ...SNACKBAR_OPTIONS, autoHideDuration: 6000 });
  };

  const warningSnackbar = (message) =>
    enqueueSnackbar(message, { variant: 'warning', ...SNACKBAR_OPTIONS });

  const infoSnackbar = (message) =>
    enqueueSnackbar(message, { variant: 'info', ...SNACKBAR_OPTIONS });

  // Kept for backwards compatibility — some callers use alertSnackbar
  const alertSnackbar = warningSnackbar;

  return { successSnackbar, errorSnackbar, warningSnackbar, infoSnackbar, alertSnackbar };
}
